/**
 * JSON-safe deep clone for workspace-shaped data. Workspace state (and its
 * nested canvas/grid/objects/view) is plain, JSON-serializable domain data
 * that flows in and out of Vue's reactivity system (ref/reactive proxies) and
 * across the network as the persisted payload. `structuredClone` is NOT safe
 * here — cloning a Vue reactive Proxy through the browser's structured-clone
 * algorithm can throw `DataCloneError`. JSON round-tripping instead reads
 * plain values through whatever get traps are present, producing an
 * independent, non-reactive, non-proxied plain object — and is intrinsically
 * the same serialization boundary the server persistence contract already
 * requires, so nothing can enter history that could not also be persisted.
 *
 * This is the one shared clone boundary for workspace data — used by both
 * `createWorkspacePersistence.js` (the save-queue snapshot) and
 * `workspaceHistory.js` (Undo/Redo snapshots), rather than each maintaining
 * its own implementation.
 */
export function cloneWorkspaceValue(value) {
  return JSON.parse(JSON.stringify(value));
}
